module.exports = __webpack_public_path__ + "img/card2-bl3.8aa87971.svg";